import { Typography } from '@material-ui/core';

const ContactInfoItem = ({ label, value, isLink = false, linkHref, linkTarget, isRtl = false, onClick }) => {
  const isReactNode = typeof value !== 'string' && typeof value !== 'number';

  return (
    <div>
      {label && (
        <Typography variant="body2" component="p" className="!font-bold mb-1">
          {label}
        </Typography>
      )}
      {isLink ? (
        <Typography variant="body1" className="">
          <a
            href={linkHref}
            target={linkTarget}
            rel={linkTarget === '_blank' ? 'noopener noreferrer' : undefined}
            className="underline"
            onClick={onClick}
          >
            {value}
          </a>
        </Typography>
      ) : isReactNode ? (
        <div>{value}</div>
      ) : (
        <Typography variant="body1" className="">
          {value}
        </Typography>
      )}
    </div>
  );
};

export default ContactInfoItem;
